import { Checkbox as MuiCheckbox, SvgIcon } from '@mui/material';
import { FormControlLabel } from './FormControlLabel';
import type { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

export type CheckboxProps = MuiCheckboxProps & { label?: string };

const checkedIcon = (
  <SvgIcon viewBox="0 0 24 24">
    <rect width="24" height="24" rx="3" fill="currentColor" />
    <path
      d="m6.5 12.4 3.5 3.5 7.5-7.5"
      fill="none"
      stroke="#ffffff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </SvgIcon>
);

export const Checkbox = ({ label, ...rest }: CheckboxProps): JSX.Element =>
  label ? (
    <FormControlLabel control={<MuiCheckbox checkedIcon={checkedIcon} {...rest} />} label={label} />
  ) : (
    <MuiCheckbox checkedIcon={checkedIcon} {...rest} />
  );
